import { useLocation, useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';

const CREATE_WITH_AI_QUERY_PARAM = 'create_with_ai';

export const useOpenAiChatTrigger = (
  openAIChat: () => void,
  modalVisible: boolean
) => {
  const location = useLocation();
  const history = useHistory();
  const [shouldRemoveParam, setShouldRemoveParam] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.has(CREATE_WITH_AI_QUERY_PARAM)) {
      openAIChat();
      setShouldRemoveParam(true);
    }
  }, [location, history, openAIChat]);

  useEffect(() => {
    if (shouldRemoveParam && modalVisible) {
      const queryParams = new URLSearchParams(location.search);
      queryParams.delete(CREATE_WITH_AI_QUERY_PARAM);
      history.replace({
        pathname: location.pathname,
        search: queryParams.toString(),
      });
      setShouldRemoveParam(false);
    }
  }, [
    shouldRemoveParam,
    modalVisible,
    location.pathname,
    location.search,
    history,
  ]);
};
